
export class TimeTracker {
  private startTime: number

  constructor() {
    this.startTime = Date.now()
  }

  getElapsedTime(): number {
    return Date.now() - this.startTime
  }

  getElapsedSeconds(): number {
    return this.getElapsedTime() / 1000
  }

  estimateTimeRemaining(processed: number, total: number): string | undefined {
    if (processed === 0 || total === 0) return undefined
    
    const elapsedSeconds = this.getElapsedSeconds()
    const processingSpeed = processed / elapsedSeconds
    const remaining = total - processed
    const timeRemaining = remaining / processingSpeed
    
    const minutes = Math.floor(timeRemaining / 60)
    const seconds = Math.floor(timeRemaining % 60)
    
    return `${minutes}m ${seconds}s`
  }

  getProcessingSpeed(processed: number): number {
    const elapsedSeconds = this.getElapsedSeconds()
    return processed / elapsedSeconds
  }
}
